import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { lighten } from 'polished';

export const Container = styled.div`
  background: #36394c;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;

  button {
    background: none;
    border: 0;
  }
`;

export const Perfil = styled.button`
  display: flex;
  align-items: center;
  text-align: right;
  background: none;
  border: 0;
  position: relative;
  padding: 5px 0;

  > img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
  }

  div {
    margin-right: 5px;
    h4 {
      color: #fff;
      font-weight: bold;
      font-size: 14px;
    }

    span {
      color: rgba(255, 255, 255, 0.5);
      font-size: 12px;
    }
  }
`;

export const Menus = styled.div`
  position: absolute;
  border-radius: 4px;
  left: calc(50% - 90px);
  top: calc(100% + 15px);
  width: 150px;
  background: #2e3648;
  display: ${props => (props.visible ? 'flex' : 'none')};
  padding: 10px 0;
  flex-direction: column;
  z-index: 999;

  > button {
    background: none;
    border: 0;
  }
`;

export const Menu = styled(Link)`
  padding: 10px 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: background 0.2s;
  margin-top: 5px;

  &:hover {
    background: ${lighten(0.04, '#2e3648')};
  }

  svg {
    margin-right: 5px;
  }

  span {
    color: ${props => (props.logout ? '#ec4561' : '#FFF')};
  }
`;

export const Resetar = styled.button.attrs({
  type: 'button',
})`
  padding: 10px 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: background 0.2s;
  margin-top: 5px;
  background: none;
  border: none;

  &:hover {
    background: ${lighten(0.04, '#2e3648')};
  }

  svg {
    margin-right: 5px;
  }

  span {
    color: ${props => (props.logout ? '#ec4561' : '#FFF')};
  }
`;

export const Logout = styled.div`
  padding: 10px 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: background 0.2s;
  margin-top: 5px;

  &:hover {
    background: ${lighten(0.04, '#2e3648')};
  }

  svg {
    margin-right: 5px;
  }

  span {
    color: #ec4561;
  }
`;

export const Tests = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  padding: 6px 20px;
  align-items: center;
  background: #ec4561;
  color: #fff;
`;
